"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimType = exports.UsersClaims = void 0;
var UsersClaims;
(function (UsersClaims) {
    UsersClaims["OFFICE_CREDITORS_VIEW"] = "office.creditors.view";
    UsersClaims["TEAM_CREDITORS_VIEW"] = "team.creditors.view";
    UsersClaims["CLOSURE_UPDATE"] = "closure.update";
    UsersClaims["CLOSURE_UNFINISHED_VIEW"] = "closure.unfinished.view";
    UsersClaims["USER_CREATE"] = "user.create";
    UsersClaims["DETAILSTABLE_HIDDEN_COLUMNS"] = "detailstable.hidden.columns";
    UsersClaims["PAYSLIP_VIEW"] = "payslip.view";
    UsersClaims["PAYROLL_VIEW"] = "payroll.view";
    UsersClaims["HIDE_DIVISION_DETAILS"] = "division.details.hide";
    UsersClaims["FEATURE_CREDITOR_NAME_ON_RULES"] = "feature.creditor.name.on.rules";
    UsersClaims["OFFICE_LOGO_URL"] = "office.logo.url";
    UsersClaims["CREDITOR_REPORT_ROA_VIEW"] = "creditor.report.roa.view";
    UsersClaims["ALL_COMMISSIONS_TABLE"] = "feature.all.commissions.table";
    UsersClaims["BACKOFFICE"] = "backoffice";
    UsersClaims["MIGRATION_UNION_V2"] = "migration.union.v2";
    UsersClaims["GROSS_COMMISSION_AMOUNT"] = "feature.gross.commission.amount";
    UsersClaims["FEATURE_USER_AMOUNT_AGREEMENT"] = "feature.user.amount.agreement";
    UsersClaims["PERMISSION_PAYMENTS"] = "permission.payments";
    UsersClaims["EXPORT_ARBITRARY_FIELDS"] = "export.arbitrary.fields";
    UsersClaims["FEATURE_GOALS_CONFIG"] = "feature.goals.config";
    UsersClaims["FEATURE_SEE_OWNED_COMMISSIONS"] = "feature.see.owned.commissions";
    UsersClaims["CUSTOM_REPORTS"] = "custom.reports";
    UsersClaims["ADJUSTMENT_REQUEST_VIEW"] = "adjustment.request.view";
    UsersClaims["CUSTOMIZED_TABLE"] = "feature.customized.table";
    UsersClaims["SHEET_DATA_SOURCE"] = "feature.sheet.data.source";
    UsersClaims["FEATURE_VARIABLES"] = "feature.variables";
    UsersClaims["UNCAPPED_RULES"] = "uncapped.rules";
    UsersClaims["USER_PREFERENCES"] = "user.preferences";
    UsersClaims["THEME_CONFIG"] = "theme.config";
    UsersClaims["GENERIC_DATA_IMPORT"] = "generic.data.import";
    UsersClaims["DOCUMENT_MANAGEMENT"] = "feature.document.management";
    UsersClaims["FEATURE_TEAM_VARIABLES_VIEW"] = "feature.team.variables.view";
    UsersClaims["USER_MESSAGES"] = "user.messages";
    UsersClaims["APPLY_RULES_FUTURE_CLOSURES"] = "future.closure.rules";
    UsersClaims["TEAMS_VIEW_PERMISSION"] = "teams.view.permission";
    UsersClaims["CREDITORS_VIEW_PERMISSION"] = "creditors.view.permission";
    UsersClaims["NOTIFY_ANSWERED_QUESTION"] = "notify.answered.question";
    UsersClaims["NOTIFY_QUESTIONED"] = "notify.questioned";
    UsersClaims["NOTIFY_PAYMENT_RECEIVED"] = "notify.payment.received";
    UsersClaims["DISABLE_SPLITC_REFERRAL"] = "disable.splitc.referral";
    UsersClaims["OFFICE_SSO_CONFIG"] = "office.sso.config";
    UsersClaims["XP_INTEGRATION_CONFIG"] = "xp.integration.config";
    UsersClaims["DISABLE_ALL_COMMISSIONS_TABLE"] = "disable.all.commissions.table";
    UsersClaims["DISABLE_HOME_MONTH_EARNING"] = "disable.home.month.earning";
    UsersClaims["GOAL_APPEARANCE_CONFIG"] = "goal.appearance.config";
    UsersClaims["MANAGE_PERMISSION_PROFILES"] = "manage.permission.profiles";
    UsersClaims["MANAGE_OFFICE_PERMISSIONS"] = "manage.office.permissions";
    UsersClaims["OFFICE_LOGIN_CONFIG"] = "office.login.config";
    UsersClaims["HIDE_REPORTS"] = "hide.reports";
    UsersClaims["HIDE_SPLITC_LOGO"] = "hide.splitc.logo";
    UsersClaims["HIDE_LOGOUT"] = "hide.logout";
    UsersClaims["FEATURE_DIVISION_ROUNDING"] = "feature.division.rounding";
    UsersClaims["FEATURE_INACTIVITY_LOGOUT"] = "feature.inactivity.logout";
    UsersClaims["STATEMENT_PANEL_VISIBLE"] = "statement.panel.visible";
    UsersClaims["UPSERT_CUSTOMERS_NAME"] = "upsert.customers.name";
    UsersClaims["COMPANY_MANAGEMENT"] = "company.management";
    UsersClaims["CREDITOR_PAYMENT_INFO_VIEW"] = "creditor.payment.info.view";
    UsersClaims["CREDITOR_PAYMENT_INFO_WRITE"] = "creditor.payment.info.write";
    UsersClaims["INQUIRIES_MANAGEMENT"] = "inquiries.management";
    UsersClaims["HIDE_OLD_HOME"] = "hide.old.home";
    UsersClaims["ALLOW_USER_IMPERSONATION"] = "allow.user.impersonation";
    UsersClaims["PREVENT_USER_DELETION"] = "prevent.user.deletion";
    UsersClaims["FEATURE_PAYROLL_V2"] = "feature.payroll.v2";
    UsersClaims["CLOSURE_SHOW_HIDDEN_MESSAGE"] = "closure.show.hidden.message";
    UsersClaims["PAYROLL_STATUS_MANAGER"] = "payroll.status.manager";
    UsersClaims["USER_MANAGEMENT"] = "user.management";
    UsersClaims["AUTOMATIC_BACKUP_CLOSURES"] = "automatic_backup_closures";
    UsersClaims["PLAN_GROUP_PERMISSIONS"] = "plan.group.permissions";
    UsersClaims["REQUIRED_INQUIRY_TAG"] = "required.inquiry.tag";
    UsersClaims["FEATURE_PAYROLL_REQUESTS"] = "feature.payroll.requests";
    UsersClaims["PAYROLL_NOTIFICATION"] = "payroll.notification";
    UsersClaims["LANGUAGE_PREFERENCE"] = "language.preference";
    UsersClaims["EXPORT_CREDITOR_TEAMS_FIELD"] = "export.creditor.teams.field";
    UsersClaims["POLICY_AGREEMENT_MANAGER"] = "policy.agreement.manager";
    UsersClaims["POLICY_AGREEMENT_MODULE"] = "policy.agreement.module";
    UsersClaims["ALLOW_CREDENTIALS_MANAGEMENT"] = "allow.credentials.management";
})(UsersClaims = exports.UsersClaims || (exports.UsersClaims = {}));
var ClaimType;
(function (ClaimType) {
    ClaimType["BOOLEAN"] = "boolean";
    ClaimType["STRING"] = "string";
    ClaimType["OBJECT"] = "object";
    ClaimType["STRING_ARRAY"] = "STRING_ARRAY";
    ClaimType["CSV_STRING_ARRAY"] = "CSV_STRING_ARRAY";
})(ClaimType = exports.ClaimType || (exports.ClaimType = {}));
